export const createQueryKey = (ogKey: string, key?: string | string[]) => {
  if (Array.isArray(key)) {
    return [ogKey, ...key];
  } else {
    return [ogKey, key];
  }
};
